import { connect } from 'react-redux';
import NoActiveBallots from 'components/currentBallots/NoActiveBallots';

const mapStateToProps = ({ noBallotStatus }) => ({
  title: noBallotStatus.title,
  description: noBallotStatus.description,
});

export default connect(mapStateToProps, null)(NoActiveBallots);
